import { handleGqlResponseBody } from "@/utils/apollo.util";
import { GET_ROOMS_PAGINATION_QUERY } from "@/graphql/queries/configuration/room/get-rooms-pagination.query";

const room = {
  actions: {
    async getRoomsQuery({ commit }, { skip, take, orderBy, query, floorId }) {
      return await handleGqlResponseBody(({ query: queryMethod }) => {
        return queryMethod({
          query: GET_ROOMS_PAGINATION_QUERY,
          variables: {
            skip,
            take,
            orderBy,
            query,
            floorId,
          },
          fetchPolicy: "no-cache",
        });
      });
    },
  },
};

export default room;
